/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import LinearProgress from "@mui/material/LinearProgress";
import OGBox from "assets/theme/components/OGBox";
import OGTypography from "assets/theme/components/OGTypography";
import boxShadows from "assets/theme/theme-light/base/boxShadows";
import backgroundImageDay from "assets/images/others/bg-maintenance-mode.jpg";
import { useThemeUIController } from "context";

function TabPanelDay(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
    >
      {value === index && (
        <OGBox sx={{ p: 0 }}>
          <OGTypography>{children}</OGTypography>
        </OGBox>
      )}
    </div>
  );
}

function PredictionsByLeague(props) {
  const [controller] = useThemeUIController();
  const { darkMode } = controller;

  return (
    <OGBox p={1}>
      <OGBox sx={{ display: "flex", justifyContent: "center" }}>
        <OGBox
          sx={{
            height: 400,
            backgroundImage: darkMode ? `url(${backgroundImageDay})` : `url(${backgroundImageDay})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          width="100%"
          borderRadius="md"
        >
          <Card sx={{ opacity: 0.9 }}>
            <OGTypography
              sx={{ opacity: 1, m: 2, fontSize: 32, fontWeight: "bold", color: "#0fdb49" }}
            >
              MAINTENANCE UPGRADE
            </OGTypography>
            <OGBox sx={{ display: "flex", justifyContent: "center" }}>
              <OGBox width="100%" m={1}>
                <LinearProgress />
              </OGBox>
            </OGBox>
          </Card>
        </OGBox>
      </OGBox>
    </OGBox>
  );
}

TabPanelDay.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default PredictionsByLeague;
